module.exports = __webpack_public_path__ + "static/media/logo-icon_viarota.9f93e73b.png";